import * as React from 'react';
import { ScrollView, View } from 'react-native';
import { styles } from 'styles/screens/loginScreen';
import useChangeAuthData from 'hooks/useChangeAuthData';
import LoginForm from 'forms/LoginForm';
import LoginScreenProps from 'types/screens/LoginScreenProps';
import { getAuthData } from 'services/authService';

export default ({ route }: LoginScreenProps): JSX.Element => {
  const { storeAuthData } = useChangeAuthData();

  const loadUserbyToken = async (): Promise<void> => {
    const params = route.params;
    if (params) {
      const { token } = params;
      if (!token) return;
      const user = await getAuthData(token);
      if (user) storeAuthData({ token, user });
    }
  };

  React.useEffect(() => {
    loadUserbyToken();
  }, []);

  return (
    <ScrollView style={{ flex: 1 }} contentContainerStyle={styles.scrollContainer} keyboardShouldPersistTaps="handled">
      <View style={styles.formWrapper}>
        <LoginForm />
      </View>
    </ScrollView>
  );
};
